import { Route, Routes } from "react-router-dom";
import { PortalProvider } from "./lib/portal";
import PublicLayout from "./components/PublicLayout";
import HomePage from "./pages/HomePage";
import OverviewPage from "./pages/OverviewPage";
import MenuPage from "./pages/MenuPage";
import VotingPage from "./pages/VotingPage";
import BudgetPage from "./pages/BudgetPage";
import FAQPage from "./pages/FAQPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import NotFoundPage from "./pages/NotFoundPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

export default function App() {
  return (
    <PortalProvider>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/voting" element={<VotingPage />} />
          <Route path="/budget" element={<BudgetPage />} />
          <Route path="/faq" element={<FAQPage />} />
        </Route>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PortalProvider>
  );
}
